/**
 * simple_hero Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initsimple_hero() {
    const blocks = document.querySelectorAll(".simple_hero");

    blocks.forEach((block) => {
      // Initialize image crossfade animations
      initImageCrossfade(block);
    });
  }

  /**
   * Initialize GSAP crossfade animation for image galleries
   */
  function initImageCrossfade(block) {
    // Wait for GSAP to be available (may load async)
    let retryCount = 0;
    const maxRetries = 50; // 5 seconds max wait

    function checkGSAP() {
      retryCount++;

      // Check multiple ways GSAP might be available
      let gsapLib = null;

      if (typeof gsap !== "undefined") {
        gsapLib = gsap;
      } else if (typeof window.gsap !== "undefined") {
        gsapLib = window.gsap;
      } else if (
        window.SOJ_GSAP_ANIMATIONS &&
        window.SOJ_GSAP_ANIMATIONS.gsap
      ) {
        gsapLib = window.SOJ_GSAP_ANIMATIONS.gsap;
      }

      if (!gsapLib) {
        if (retryCount < maxRetries) {
          // Retry after a short delay if GSAP isn't loaded yet
          setTimeout(checkGSAP, 100);
          return;
        } else {
          return;
        }
      }

      // Find all image containers in simple_hero block
      const image1Container = block.querySelector(".image1");
      const image2Container = block.querySelector(".image2");
      const image3Container = block.querySelector(".image3");
      const image4Container = block.querySelector(".image4");
      const image5Container = block.querySelector(".image5");
      const image6Container = block.querySelector(".image6");

      // Find intro-block on the page and get its images
      const introBlock = document.querySelector(".intro-block");
      const introImage1Container = introBlock
        ? introBlock.querySelector(".image1")
        : null;
      const introImage2Container = introBlock
        ? introBlock.querySelector(".image2")
        : null;
      const introImage3Container = introBlock
        ? introBlock.querySelector(".image3")
        : null;
      const introImage4Container = introBlock
        ? introBlock.querySelector(".image4")
        : null;
      const introImage5Container = introBlock
        ? introBlock.querySelector(".image5")
        : null;
      const introImage6Container = introBlock
        ? introBlock.querySelector(".image6")
        : null;

      // Helper function to determine slide direction based on grid position
      const getSlideDirection = (container) => {
        if (!container) return "left";
        // Check grid-column-start to determine if it's on left or right
        const style = window.getComputedStyle(container);
        const gridColumn = style.gridColumnStart || style.gridColumn;

        // If grid-column-start is 1 or 2, it's on the left
        // If it's 3, 4, or 5, it's on the right
        if (gridColumn) {
          const start = parseInt(gridColumn);
          if (start <= 2) return "left";
          if (start >= 3) return "right";
        }

        // Fallback: check class name - odd numbers (1,3,5) slide from left, even (2,4,6) from right
        const className = container.className;
        const match = className.match(/image(\d+)/);
        if (match) {
          const imageNum = parseInt(match[1]);
          return imageNum % 2 === 1 ? "left" : "right";
        }

        return "left"; // Default to left
      };

      // Group containers with their slide directions: [1,2], [3,4], [5,6]
      // Include both simple_hero and intro-block images in each group
      const groups = [
        [
          {
            container: image1Container,
            direction: getSlideDirection(image1Container),
          },
          {
            container: image2Container,
            direction: getSlideDirection(image2Container),
          },
          {
            container: introImage1Container,
            direction: getSlideDirection(introImage1Container),
          },
          {
            container: introImage2Container,
            direction: getSlideDirection(introImage2Container),
          },
        ].filter((item) => item.container), // Group 1: images 1 and 2 (simple_hero + intro)
        [
          {
            container: image3Container,
            direction: getSlideDirection(image3Container),
          },
          {
            container: image4Container,
            direction: getSlideDirection(image4Container),
          },
          {
            container: introImage3Container,
            direction: getSlideDirection(introImage3Container),
          },
          {
            container: introImage4Container,
            direction: getSlideDirection(introImage4Container),
          },
        ].filter((item) => item.container), // Group 2: images 3 and 4 (simple_hero + intro)
        [
          {
            container: image5Container,
            direction: getSlideDirection(image5Container),
          },
          {
            container: image6Container,
            direction: getSlideDirection(image6Container),
          },
          {
            container: introImage5Container,
            direction: getSlideDirection(introImage5Container),
          },
          {
            container: introImage6Container,
            direction: getSlideDirection(introImage6Container),
          },
        ].filter((item) => item.container), // Group 3: images 5 and 6 (simple_hero + intro)
      ];

      // Filter out empty groups
      const validGroups = groups.filter((group) => group.length > 0);

      // Check if mobile (under 768px)
      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        // Mobile: Fade in first group (images 1 and 2) once, then leave them visible
        validGroups.forEach((group, groupIndex) => {
          group.forEach((item) => {
            const container = item.container;
            if (groupIndex === 0) {
              // First group - fade in once and leave visible
              gsapLib.set(container, { opacity: 0, x: 0, y: 0 });
              gsapLib.to(container, {
                opacity: 1,
                duration: 1,
                ease: "power2.inOut",
              });
            } else {
              // All other groups - hide completely
              container.style.opacity = "0";
              container.style.display = "none";
            }
          });
        });
      } else {
        // Desktop: Run animation
        // Immediately hide all groups except the first one (before GSAP animation)
        validGroups.forEach((group, groupIndex) => {
          group.forEach((item) => {
            const container = item.container;
            if (!container) return; // Skip if container doesn't exist
            container.style.display = ""; // Reset display
            if (groupIndex === 0) {
              // First group - make visible and in position
              container.style.opacity = "1";
              container.style.transform = "translate(0, 0)";
            } else {
              // All other groups - hide immediately and positioned off-screen
              const xOffset = item.direction === "left" ? 0 : 0;
              container.style.opacity = "0";
              container.style.transform = `translate(${xOffset}px, 50px)`;
            }
          });
        });

        if (validGroups.length > 1) {
          createGroupedCrossfadeAnimation(validGroups, 0.5, gsapLib);
        } else if (validGroups.length === 1) {
          // Only one group - make sure it's visible
          validGroups[0].forEach((item) => {
            gsapLib.set(item.container, { opacity: 1 });
          });
        }
      }
    }

    checkGSAP();
  }

  /**
   * Create GSAP grouped crossfade animation timeline
   * Images fade in one at a time, then fade out one at a time
   */
  function createGroupedCrossfadeAnimation(
    groups,
    displayDuration = 0,
    gsapLib
  ) {
    if (groups.length < 2) return;
    if (!gsapLib) {
      return;
    }

    const fadeDuration = 1; // Duration for fade in/out
    const imageDelay = 0.2; // Delay between images in the same group

    // Set initial state - first group visible, all others hidden
    groups.forEach((group, groupIndex) => {
      group.forEach((item, imageIndex) => {
        const container = item.container;
        if (!container) return; // Skip if container doesn't exist
        const direction = item.direction;
        const xOffset = direction === "left" ? 0 : 0;

        if (groupIndex === 0) {
          // First group - all images visible
          gsapLib.set(container, { opacity: 1, x: 0, y: 0 });
        } else {
          // All other groups - hidden and positioned off-screen
          gsapLib.set(container, { opacity: 0, x: xOffset, y: 50 });
        }
      });
    });

    // Create timeline that loops infinitely
    const tl = gsapLib.timeline({ repeat: -1, paused: false });

    let currentTime = 0.7; // 2 second delay before animations start

    // Process each group
    groups.forEach((group, groupIndex) => {
      // Calculate timing for this group
      // Each group: fade in images sequentially, display, then fade out images sequentially
      const groupStartTime = currentTime;

      // Fade in images one at a time
      group.forEach((item, imageIndex) => {
        const container = item.container;
        if (!container) return; // Skip if container doesn't exist
        const direction = item.direction;
        const xOffset = direction === "left" ? -0 : 0;
        const fadeInTime = groupStartTime + imageIndex * imageDelay;

        tl.fromTo(
          container,
          {
            opacity: 0,
            x: xOffset, // Start from left or right
            y: 20, // Start 20px below
          },
          {
            opacity: 1,
            x: 0, // Slide to center
            y: 0, // Slide up to position
            duration: fadeDuration,
            ease: "power2.easeOut",
          },
          fadeInTime
        );
      });

      // After all images in group have faded in, wait for display duration
      const displayStartTime =
        groupStartTime + (group.length - 1) * imageDelay + fadeDuration;
      const displayEndTime = displayStartTime + displayDuration;

      // Fade out images one at a time
      group.forEach((item, imageIndex) => {
        const container = item.container;
        if (!container) return; // Skip if container doesn't exist
        const fadeOutTime = displayEndTime + imageIndex * imageDelay;
        tl.to(
          container,
          {
            opacity: 0,
            y: -20, // Move back up
            duration: 0.6,
            ease: "power2.easeOut",
          },
          fadeOutTime
        );
      });

      // Update currentTime for next group
      // Total time for this group: fade in time + display + fade out time
      const totalGroupTime =
        (group.length - 1) * imageDelay +
        fadeDuration +
        displayDuration +
        (group.length - 1) * imageDelay +
        fadeDuration;
      currentTime = groupStartTime + totalGroupTime;
    });

    return tl;
  }

  // Handle window resize to toggle between mobile and desktop behavior
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Re-initialize on resize to handle mobile/desktop switch
      initsimple_hero();
    }, 250);
  });

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initsimple_hero);
  } else {
    initsimple_hero();
  }
})();
